export const filtersConfigTemplates = [
  {
    name: "knowledgeDomain",
    label: { he: "תחום דעת", ar: "المجال المعرفي" },
    fromData: {
      courseKeys: ["domain",],
      filterBy: "domain",
      extract: "array",
      labelFrom: "domains",
    },
  },
  {
    name: "tags",
    label: { he: "סגנון שיעור", ar: "أسلوب الدرس" },
    fromData: {
      courseKeys: ["tags"],
      filterBy: "tags",
      extract: "array",
      labelFrom: "tags",
    },
  },
  {
    name: "providerName",
    label: { he: "סביבות למידה", ar: "بيئات التعلّم" },
    fromData: {
      courseKeys: ["providerName"],
      filterBy: "providerName",
      labelFrom: "providers",
    },
  },
  {
    name: "language",
    label: { he: "שפה", ar: "اللغة" },
    fromJson: {
      options: [
        { id: "he", filterBy: "languages", value: "he", label: { he: "עברית", ar: "عברية" } },
        { id: "ar", filterBy: "languages", value: "ar", label: { he: "ערבית", ar: "عربية" } },
      ],
    },
  },
  {
    name: "schoolLevel",
    label: { he: "כיתות", ar: "مرحلة الدراسة" },
    teacherOnly: true,
    fromJson: {
      options: [
        { id: "elementary", operator: "class_range_overlap", value: { from: 1, to: 6 }, label: { he: "יסודי", ar: "ابتدائي" } },
        { id: "middleSchool", operator: "class_range_overlap", value: { from: 7, to: 8 }, label: { he: "חטיבת ביניים", ar: "متوسطة" } },
        { id: "highSchool", operator: "class_range_overlap", value: { from: 8, to: 12 }, label: { he: "תיכון", ar: "ثانوية" } },
      ],
    },
  },
];

export const DEFAULT_FILTER_KEYS = ["languages"];

export const freeSearchConfig = {
  param: "free",
  filter: (value) => value
    ? [{
      group: [
        "name",
        "description",
        "tags",
        "searchIncludeKeys",
        "teacherDescription",
        "teacherName",
        "category",
      ].map((field) => ({
        by: field,
        value,
        operator: "contains",
      })),
      op: "OR",
    }]
    : [],
};
